import { PeriodScore } from '../../api/sbapi/sbapi-api-model';

const isTeamLeading = (teamScore: number | null, opponentScore: number | null): boolean => {
	if (teamScore == null || opponentScore == null) {
		return false;
	}
	return teamScore > opponentScore;
};

const isTeamLeadingOrTied = (teamScore: number | null, opponentScore: number | null): boolean => {
	if (teamScore == null || opponentScore == null) {
		return false;
	}
	return teamScore >= opponentScore;
};

const splitPeriodsToOngoingAndFinished = (
	periodScores: PeriodScore[]
): { ongoingPeriod: PeriodScore | undefined; finishedPeriods: PeriodScore[] } => {
	const ongoingPeriod = periodScores.at(-1);
	const finishedPeriods = periodScores.slice(0, -1);

	return { ongoingPeriod, finishedPeriods };
};

export { isTeamLeading, isTeamLeadingOrTied, splitPeriodsToOngoingAndFinished };
